module.exports = __webpack_public_path__ + "img/audit_error.afdf1efa.png";